import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SelectAllItemsControls from '@Containers/ResultToolbar/SelectedItemsControls/SelectAllItemsControls';
import SwitchBox from '@Components/SwitchBox/SwitchBox';

import './StepSelectionHeader.theme.scss';

/* eslint-disable react-hooks/exhaustive-deps */
function StepSelectionHeader({ selectedRowsCount, maxRowsCount, selectAllHandler, isViewOnlySelected, setViewOnlySelected }) {
  const [isAllRowsSelected, setAllRowsSelected] = useState(false);

  const checkAllSteps = (selected) => {
    setAllRowsSelected(selected);
    selectAllHandler(selected);
  };

  useEffect(() => {
    if (isAllRowsSelected && selectedRowsCount < maxRowsCount) {
      setAllRowsSelected(false);
    } else if (!isAllRowsSelected && selectedRowsCount > 0 && selectedRowsCount === maxRowsCount) {
      setAllRowsSelected(true);
    }
  }, [selectedRowsCount]);

  return (
    <div className="project-route-step-selection">
      <SelectAllItemsControls
        checkAllItems={checkAllSteps}
        allItemsSelected={isAllRowsSelected}
        currentSelectedItems={selectedRowsCount}
        someItemsSelected={selectedRowsCount > 0 && selectedRowsCount < maxRowsCount}
      />
      <div className="project-route-step-selection--view-selected-wrapper">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="project-route-step-selection--view-selected-label">
          <SwitchBox
            checked={isViewOnlySelected}
            onChange={setViewOnlySelected}
            disabled={selectedRowsCount === 0}
            size="xs"
            className="project-route-step-selection--view-selected"
            ariaLabel="View selected"
            name="viewSelected"
            e2eName="viewSelected"
          />
          View selected
        </label>
      </div>
    </div>
  );
}

StepSelectionHeader.propTypes = {
  selectedRowsCount: PropTypes.number,
  maxRowsCount: PropTypes.number,
  selectAllHandler: PropTypes.func,
  setViewOnlySelected: PropTypes.func,
  isViewOnlySelected: PropTypes.bool,
};

export default StepSelectionHeader;
